if (!customElements.get('hover-list')) {
    customElements.define(
      'hover-list',
      class HoverList extends HTMLElement {
        constructor() {
            super();
            this.linkItems = this.querySelectorAll('.hover-link')
            this.bindEvents();
        }
  
        bindEvents() {
            this.linkItems.forEach((link) =>
                link.addEventListener('mouseover', this.onLinkHover.bind(this))
            );
            this.linkItems.forEach((link) =>
                link.addEventListener('mouseout', this.onMouseOut.bind(this))
            );
        }
  
        onLinkHover(event) {
            event.preventDefault();

            this.linkItems.forEach((el) => {
                if (el == event.currentTarget) {
                    el.classList.add('active')
                    el.classList.remove('inactive')
                } else {
                    el.classList.remove('active')
                    el.classList.add('inactive')
                }
            })
        }

        onMouseOut(event) {
            event.preventDefault();

            this.linkItems.forEach((el) => {
                el.classList.remove('active')
                el.classList.remove('inactive')
            })
        }
      }
    );
}